import { IDocumentTokenDto } from "@/models/document-token.entity";
import { VuetifyMaterialColorEnum } from "@/lib/enum/vuetify-color.enum";
import { BaseTokenEntity } from "./base-token.entity";

export class FreitextTokenEntity extends BaseTokenEntity {
  static readonly token = "value";

  fontSize: number;

  constructor(
    data: Partial<FreitextTokenEntity> & {
      x: number;
      y: number;
      w?: number;
      h?: number;
    }
  ) {
    super(data);
    this.fontSize = data.fontSize ?? 12;
  }

  get tokenString() {
    return FreitextTokenEntity.token;
  }

  get colorHex() {
    return VuetifyMaterialColorEnum.BLUE_GREY;
  }

  get icon() {
    return "mdi-form-textbox";
  }

  get color() {
    return "blue-grey";
  }

  get labelKey() {
    return "sign.fieldType.value";
  }

  get defaultSize() {
    return { w: 0.3, h: 0.02 };
  }

  get fixedSize() {
    return false;
  }

  validateConstraints(pageWidthMm?: number, pageHeightMm?: number) {
    if (!pageHeightMm) return;
    this.y = Math.max(0, Math.min(pageHeightMm - this.h, this.y));
  }

  toDto(widthPx: number, heightPx: number): IDocumentTokenDto {
    return this.buildDto(widthPx, heightPx, this.fontSize);
  }
}
